import { render, staticRenderFns } from "./NoDataPlaceHolder.vue?vue&type=template&id=11165096&scoped=true&functional=true&"
var script = {}
import style0 from "./NoDataPlaceHolder.vue?vue&type=style&index=0&id=11165096&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "11165096",
  null
  
)

export default component.exports